@if (storyCommentsLoaded) {
  @if (storyComments.length > 0) {
    <div class="box-comment">
      @for (storyComment of storyComments; track storyComment.id) {
        <app-story-comment-detail-student [storyComment]="storyComment"> </app-story-comment-detail-student>
      }
      @if (canLoadMore) {
        <div class="load-more">
          <a class="spen-util-link" (click)="loadMoreStoryComments()">
            <span>もっと見る</span>
            <i [class]="isLoadingMore ? 'fa fa-spinner fa-spin' : 'fa fa-chevron-down'"></i>
          </a>
        </div>
      }
    </div>
  }
  @if (storyComments.length === 0) {
    <div class="empty-message">ここに先生からのひとことが表示されます。</div>
  }
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
